import { render, staticRenderFns } from "./ExpeditionDocumentsList.vue?vue&type=template&id=1721a466"
import script from "./ExpeditionDocumentsList.vue?vue&type=script&lang=js"
export * from "./ExpeditionDocumentsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports